import React, { useEffect, useState } from "react";
import axios from "axios";
import Chart from "chart.js/auto";

function BarGraph() {
  const [salesData, setSalesData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://jsonplaceholder.typicode.com/posts"
        );
        const data = response.data.slice(0, 12); // Consider only first 12 months

        // Format data for the BarGraph
        const formattedData = data.map((item, index) => ({
          month: `Month ${index + 1}`,
          product1Sales: Math.floor(Math.random() * 100), // Dummy data for product 1 sales
          product2Sales: Math.floor(Math.random() * 100), // Dummy data for product 2 sales
        }));

        setSalesData(formattedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (salesData.length === 0) return;

    // Create chart once data is available
    const ctx = document.getElementById("barGraph");

    new Chart(ctx, {
      type: "bar",
      data: {
        labels: salesData.map((item) => item.month),
        datasets: [
          {
            label: "Gemstone",
            data: salesData.map((item) => item.product1Sales),
            backgroundColor: "rgba(255, 99, 132, 0.5)",
            borderColor: "rgba(255, 99, 132, 1)",
            borderWidth: 1,
          },
          {
            label: "Industrial materials",
            data: salesData.map((item) => item.product2Sales),
            backgroundColor: "rgba(54, 162, 235, 0.5)",
            borderColor: "rgba(54, 162, 235, 1)",
            borderWidth: 1,
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
  }, [salesData]);

  return (
    <div
      style={{
        width: "600px",
        backgroundColor: "white",
        color: "white",
        border: "5px solid #ccc",
        padding: "4px",
      }}
    >
      <canvas id="barGraph" width="600" height="300"></canvas>
    </div>
  );
}

export default BarGraph;
